import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import EmployerGroupProfileContent from './EmployerGroupProfileContent';
import { NoDataPlaceholderStyled } from './styles';

const EmployerProfile = observer((): JSX.Element => {
  const {
    subscriberStore: { loading, activeGroup, groups },
    userStore: { isLoading: userStoreLoading },
  } = useRootStore();
  const isLoading = loading || userStoreLoading;
  return (
    <>
      {!isLoading && groups.length === 0 && (
        <NoDataPlaceholderStyled
          title="No groups available"
          text="Once you've been invited, your groups will appear here"
        />
      )}
      {!isLoading && activeGroup.id && <EmployerGroupProfileContent employerGroupId={activeGroup.id} />}
    </>
  );
});

export default EmployerProfile;
